import { Theme } from '@/theme';
import { useLoader } from '@CS/hooks';
import { useEffect, useState } from 'react';
import { Tile, ContentGrid } from './Tiles.styles';
import type { ISDK } from '@tbwax_dev/mcd-family-sdk';
import type { Langs } from '@CS/components/TranslationProvider/types';
import type { CampaignUnit, Translations } from '@/services/api/types';

export type Size = 'small' | 'medium' | 'large';

type TilesProps = { sdk?: ISDK; lang?: Langs };

export const Tiles = ({ sdk, lang = 'en' }: TilesProps) => {
  const [loading, setLoading] = useState(true);

  const loader = useLoader(loading, { color: Theme.color.red });
  const [tiles, setTiles] = useState<CampaignUnit[] | null>(null);

  const getTranslation = (key: string, translations?: Translations) =>
    translations?.[key]?.[lang];

  const handleClick = (href: string) => window.location.href = href;

  const getBackground = (color = '', image = '') =>
    `${color} ${image && `url(${image}) center/cover no-repeat`}`;

  const getCampaignUnits = (sdk: ISDK, useCached?: boolean) =>
    sdk.getCampaignUnits(useCached).then(setTiles);

  useEffect(() => {
    sdk && !tiles && getCampaignUnits(sdk)
        .finally(() => ~setLoading(false) && getCampaignUnits(sdk, false));
  }, [sdk]);

  return loader || (
    <ContentGrid>
      {tiles && tiles.map((tile, index) => (
        <Tile
          style={{ background: getBackground(tile.bgColor, tile.bgImageUrls?.[0]) }}
          onClick={() => handleClick(tile.ctaUrl)}
          $size={tile.itemType as Size}
          data-size={tile.itemType}
          key={index}
        >
          {tile.itemType === 'large' ? (
            <>
              <img src={tile.imageUrls[0]} alt={tile.title} width="177" height="116" />

              <div>
                <h3>{getTranslation('title', tile.translations)}</h3>
                <p>{getTranslation('description', tile.translations)}</p>
              </div>
            </>
          ) : (
            <>
              <img src={tile.imageUrls[0]} alt={tile.title} width="70" height="70" />
              <h3>{getTranslation('title', tile.translations)}</h3>
              <p>{getTranslation('description', tile.translations)}</p>
            </>
          )}
        </Tile>
      ))}
    </ContentGrid>
  );
};
